var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":function($event){return _vm.$emit('selectSite', _vm.site)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.site.site_name))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.site.publish_status))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }